module.exports = __webpack_public_path__ + "img/healthCare.a3556a0f.png";